import { gql } from '@apollo/client';

export const TelnyxQuery = gql`
  query TelnyxSearch($city: String!, $region: String!, $startsWith: String) {
    telnyxSearchPhones(region: $region, city: $city, startsWith: $startsWith) {
      monthlyCost
      oneTimeCost
      phoneNumber
      location
    }
  }
`;

export const ProvisionTelnyxMutation = gql`
  mutation ProvisionTelnyx($provisionTelnyx: ProvisionVendorInput!) {
    provisionTelnyx(provisionTelnyx: $provisionTelnyx)
  }
`;
